import { Module } from 'vuex'
import { MessengerState } from '..'

export interface ChatRoomNotificationState {
  hash: number
  unreadChats: number
  unreadNotifications: number
  unreadMy: number
  unreadCount: number
  currentChatRoomId: number
  lastMessageId: number
  lastSysNotiId: number
}

const chatRoomNotificationModule: Module<ChatRoomNotificationState, MessengerState> = {
  namespaced: true,
  state: {
    hash: 0,
    unreadChats: 0,
    unreadNotifications: 0,
    unreadMy: 0,
    unreadCount: 0,
    currentChatRoomId: -2,
    lastMessageId: 0,
    lastSysNotiId: 0,
  },
  mutations: {
    setUnreadCount (state, unreadCount: number) {
      state.unreadCount = unreadCount
      state.hash++
    },
    setUnreadChats: (state, count: number) => {
      state.unreadChats = count
      state.unreadCount = state.unreadChats + state.unreadNotifications + state.unreadMy
      state.hash++
    },
    setUnreadNotifications: (state, count: number) => {
      state.unreadNotifications = count
      state.unreadCount = state.unreadChats + state.unreadNotifications + state.unreadMy
      state.hash++
    },
    setUnreadMy: (state, count: number) => {
      state.unreadMy = count
      state.unreadCount = state.unreadChats + state.unreadNotifications + state.unreadMy
      state.hash++
    },
    // setUnreadCount (state, unreadCount: number) {
    //   state.unreadCount = unreadCount
    // },
    setCurrentChatRoomId (state, chatRoomId: number) {
      state.currentChatRoomId = chatRoomId
    },
    setLastMessageId (state, messageId: number) {
      state.lastMessageId = messageId
    },
    setLastSysNotiId (state, sysNotiId: number) {
      state.lastSysNotiId = sysNotiId
    },
  },
}

export default chatRoomNotificationModule

